import request from "./config";

export default class AdminService {
  static createExtension(data) {
    return request({
      url: "/company/create/extension",
      method: "post",
      data,
    });
  }
  static createArea(data) {
    return request({
      url: "/company/create/area",
      method: "POST",
      data,
    });
  }
  static createReport(data) {
    return request({
      url: "/company/create/report",
      method: "POST",
      data,
    });
  }
  static createSite(data) {
    return request({
      url: "/company/create/sites",
      method: "POST",
      data,
    });
  }

  static createSanction(data) {
    return request({
      url: "/company/create/sanction",
      method: "POST",
      data,
    });
  }

  static reportAll(params) {
    return request({
      url: `/admin/report-all`,
      method: "get",
      timeout: 100000,
      params: params,
    });
  }
  static reportMessagesType(params) {
    return request({
      url: `/admin/report-count-messages`,
      method: "get",
      timeout: 100000,
      params: params,
    });
  }
  static reportUsers(params) {
    return request({
      url: `/admin/report-users`,
      method: "get",
      timeout: 100000,
      params: params,
    });
  }
  static reportMessages(params) {
    return request({
      url: `/admin/report-messages`,
      method: "get",
      timeout: 100000,
      params: params,
    });
  }
  static createExtensionList(params) {
    return request({
      url: `company/` + params,
      method: "get",
      params: params,
    });
  }
  static listExtensionList(params) {
    return request({
      url: `company/create/extension/list`,
      method: "get",
      params: params,
    });
  }
  static listArea(params) {
    return request({
      url: `/company/get/area/list`,
      method: "get",
      params: params,
    });
  }
  static listSites(params) {
    return request({
      url: `/company/get/sites/list`,
      method: "get",
      params: params,
    });
  }
  static listReport(params) {
    return request({
      url: `/company/get/report/list`,
      method: "get",
      params: params,
    });
  }
  static listSanction(params) {
    return request({
      url: `/company/get/sanction/list`,
      method: "get",
      params: params,
    });
  }
  static removeExtension(data) {
    return request({
      url: `company/extension/remove`,
      method: "post",
      data,
      timeout: 100000,
    });
  }

  static updateExtension(data) {
    return request({
      url: "/company/extension/edit",
      method: "put",
      data,
      timeout: 100000,
    });
  }

  static removeArea(data) {
    return request({
      url: `company/areas/remove`,
      method: "post",
      data,
      timeout: 100000,
    });
  }

  static updateArea(data) {
    return request({
      url: "/company/areas/edit",
      method: "put",
      data,
      timeout: 100000,
    });
  }

  static removeReport(data) {
    return request({
      url: `company/reports/remove`,
      method: "post",
      data,
      timeout: 100000,
    });
  }

  static updateReports(data) {
    return request({
      url: "/company/reports/edit",
      method: "put",
      data,
      timeout: 100000,
    });
  }

  static removeSite(data) {
    return request({
      url: `company/sites/remove`,
      method: "post",
      data,
      timeout: 100000,
    });
  }

  static updateSites(data) {
    return request({
      url: "/company/sites/edit",
      method: "put",
      data,
      timeout: 100000,
    });
  }

  static removeSanction(data) {
    return request({
      url: `company/sanction/remove`,
      method: "post",
      data,
      timeout: 100000,
    });
  }

  static updateSanction(data) {
    return request({
      url: "/company/sanction/edit",
      method: "put",
      data,
      timeout: 100000,
    });
  }
  static listMessage(params) {
    return request({
      url: `company/message/list`,
      method: "get",
      params: params,
      timeout: 100000,
    });
  }
  static createCompanyAdmin(data) {
    return request({
      url: "/admin/company/create",
      method: "post",
      data,
      timeout: 100000,
    });
  }
  static createCompany(data) {
    return request({
      url: "/company/create",
      method: "post",
      data,
      timeout: 100000,
    });
  }
  static removeBusiness(data) {
    return request({
      url: "/company/remove",
      method: "post",
      data,
      timeout: 100000,
    });
  }
  static updateCompany(data) {
    return request({
      url: "/company/edit",
      method: "PUT",
      data,
      timeout: 100000,
    });
  }
  static changeBusiness(data) {
    return request({
      url: "/company/change-status",
      method: "post",
      data,
      timeout: 100000,
    });
  }
  static approveMessages(ids) {
    return request({
      url: "/company/messages/approve",
      method: "PUT",
      data: { ids },
      timeout: 30000,
    });
  }
  static createCommentReport(data) {
    return request({
      url: "/company/report/comments/create",
      method: "post",
      data,
      timeout: 100000,
    });
  }
  static changeStatusReport(data) {
    return request({
      url: "/company/change-status-report",
      method: "put",
      data,
      timeout: 100000,
    });
  }
  static chartsByArea(params) {
    return request({
      url: "/charts-by-area",
      method: "get",
      params: params,
      timeout: 100000,
    });
  }
  static emailResponse(data) {
    return request({
      url: "/company/send-email-response",
      method: "post",
      data,
      timeout: 100000,
    });
  }
  static createUsersMobile(data) {
    return request({
      url: "/company/create/users/app",
      method: "PUT",
      data,
    });
  }
  static generateRandomNumber() {
    return request({
      url: "/create/company/random",
      method: "GET",
    });
  }
  static createSanctionReport(data) {
    return request({
      url: "/company/report/sanction/create",
      method: "post",
      data,
      timeout: 100000,
    });
  }
  static generateLevelMailbox(data) {
    return request({
      url: "/company/mailbox/generate-level",
      method: "PUT",
      data,
      timeout: 100000,
    });
  }

  static getLevels() {
    return request({ url: "/level/list", method: "GET" });
  }

  // Superadmin: niveles de una empresa específica
  static getLevelsByCompany(companyId) {
    return request({ url: `/level/list/company/${companyId}`, method: "GET" });
  }

  static createLevel(data) {
    return request({ url: "/level/new", method: "POST", data });
  }

  static updateLevel(id, data) {
    return request({ url: `/level/${id}`, method: "PUT", data });
  }

  static deleteLevel(id) {
    return request({ url: `/level/${id}`, method: "DELETE" });
  }

  static getAllUsers() {
    return request({
      url: "/multiuser/all",
      method: "GET",
    });
  }

  static getCompanyManagers() {
    return request({
      url: "/multiuser/managers",
      method: "GET",
    });
  }

  // Superadmin: gestores de una empresa específica
  static getCompanyManagersByCompany(companyId) {
    return request({
      url: `/multiuser/managers/company/${companyId}`,
      method: "GET",
    });
  }

  static assignManagersToMessage(mailboxId, managerIds) {
    return request({
      url: `/company/mailbox/${mailboxId}/assign-managers`,
      method: "PUT",
      data: { managerIds },
      timeout: 100000,
    });
  }
  static saveUserCompany(data) {
    return request({
      url: "/multiuser/create",
      method: "POST",
      data,
    });
  }

  static updateUserCompany(data) {
    return request({
      url: "/multiuser/" + data._id,
      method: "PUT",
      data,
      timeout: 100000,
    });
  }

  static deleteUserCompany(data) {
    return request({
      url: "/multiuser/" + data,
      method: "DELETE",
      timeout: 100000,
    });
  }

  // Métodos para administración de documentos
  static uploadDocument(formData, onUploadProgress) {
    return request({
      url: "/documents/upload",
      method: "POST",
      data: formData,
      timeout: 300000,
      onUploadProgress
    });
  }

  static listDocuments(params = {}) {
    return request({
      url: "/documents/list",
      method: "GET",
      params
    });
  }

  static getDocument(id) {
    return request({
      url: `/documents/${id}`,
      method: "GET"
    });
  }

  static deleteDocument(data) {
    return request({
      url: "/documents/delete",
      method: "POST",
      data,
      timeout: 100000
    });
  }
  static updateDocument(formData, onUploadProgress) {
    return request({
      url: "/documents/update",
      method: "PUT",
      data: formData,
      timeout: 300000,
      onUploadProgress
    });
  }

  // ── Implicated persons ───────────────────────────────
  static uploadImplicated(data) {
    return request({
      url: "/company/implicated/upload",
      method: "POST",
      data,
      timeout: 100000,
    });
  }

  static listImplicated() {
    return request({
      url: "/company/implicated/list",
      method: "GET",
      timeout: 100000,
    });
  }

  static saveImplicatedOnReport(data) {
    return request({
      url: "/company/report/implicated",
      method: "PUT",
      data,
      timeout: 100000,
    });
  }

  static saveSanctionPerImplicated(data) {
    return request({
      url: "/company/report/sanction-per-implicated",
      method: "PUT",
      data,
      timeout: 100000,
    });
  }
}
